/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { EDIT_POLL } from "./actionTypes"
import { editPollError, editPollSuccess } from "./actions"

//Include Both Helper File with needed methods
import { updatePoll } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(updatePoll, request.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(editPollSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(editPollError(error.message))
  }
}

function* pollEditSaga() {
  yield takeEvery(EDIT_POLL, list)
}

export default pollEditSaga
